import { z } from 'zod';

import { NOTIFY_EVENTS } from '../constants.js';

import { isoDateTimeSchema } from './common.js';

const notifyEventSchema = z.enum(NOTIFY_EVENTS);

export const pushSubscriptionKeysSchema = z.object({
  p256dh: z.string().min(1).max(88),
  auth: z.string().min(1).max(32),
});

export const pushSubscribeSchema = z.object({
  endpoint: z.string().url().max(512),
  keys: pushSubscriptionKeysSchema,
});
export type PushSubscribeDto = z.infer<typeof pushSubscribeSchema>;

export const pushUnsubscribeSchema = z.object({
  endpoint: z.string().url().max(512),
});
export type PushUnsubscribeDto = z.infer<typeof pushUnsubscribeSchema>;

export const pushVapidPublicKeyResponseSchema = z.object({
  publicKey: z.string().nullable(),
});
export type PushVapidPublicKeyResponseDto = z.infer<typeof pushVapidPublicKeyResponseSchema>;

export const pushStatusResponseSchema = z.object({
  supported: z.boolean(),
  subscribed: z.boolean(),
});
export type PushStatusResponseDto = z.infer<typeof pushStatusResponseSchema>;

export const pushTriggerSchema = z.object({
  event: notifyEventSchema,
  enabled: z.boolean(),
  updatedAt: isoDateTimeSchema,
});
export type PushTriggerDto = z.infer<typeof pushTriggerSchema>;

export const updatePushTriggersSchema = z.object({
  triggers: z.array(
    z.object({ event: notifyEventSchema, enabled: z.boolean() }),
  ),
});
export type UpdatePushTriggersDto = z.infer<typeof updatePushTriggersSchema>;
